"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPixel = exports.toPixel = void 0;
/**
 * Converts a number value into a <number>px value for use as CSS rules
 */
function toPixel(value) {
    return `${value}px`;
}
exports.toPixel = toPixel;
/** Determines if a string value is able to be interpreted as a pixel value */
function isPixel(value) {
    return value.endsWith('px');
}
exports.isPixel = isPixel;
//# sourceMappingURL=PixelHelper.js.map